export const SET_QUANTITY = "hardware.SET_QUANTITY";
export const SET_FIELDS = "hardware.SET_FIELDS";
export const TOGGLE_EXPAND = "hardware.TOGGLE_EXPAND";
export const REQUEST_STOCK_LEVEL = "hardware.REQUEST_STOCK_LEVEL";
export const RECEIVE_STOCK_LEVEL = "hardware.RECEIVE_STOCK_LEVEL";
